import { MantineTheme, createStyles } from "@mantine/core";

import { SizeVariant, sizeVariants } from "./sizeVariants";
import { ButtonType, getTypeVariants } from "./typeVariants";

export const useButtonStyles = ({
  sizeVariant,
  typeVariant,
}: {
  sizeVariant: SizeVariant;
  typeVariant: ButtonType;
}) => {
  return createStyles((theme: MantineTheme) => ({
    button: {
      ...sizeVariants[sizeVariant],
      ...getTypeVariants(theme)[typeVariant],
    },
    leftIcon: {
      marginRight: "5px",
      fill: getTypeVariants(theme)[typeVariant]?.color,
    },
  }))();
};
